<template>
  <div class="dropdown">
    <button
      :id="dropdownId"
      :class="isDropdownButton"
      class="btn btn-primary"
      type="button"
      :data-bs-toggle="isDropdownButton ? 'dropdown' : null"
      aria-expanded="false"
      @click="login()"
    >
      {{ buttonLabel }}
    </button>
    <ul
      v-if="isUserConnected"
      class="dropdown-menu dropdown-menu-end"
      :aria-labelledby="dropdownId"
    >
      <li>
        <AppLink
          :class="isActiveRoute('survey.user.index')"
          class="dropdown-item"
          :href="$route('survey.user.index')"
        >
          Mes questionnaires
        </AppLink>
      </li>
      <li>
        <AppLink
          :class="isActiveRoute('survey.start')"
          class="dropdown-item"
          :href="$route('survey.start')"
        >
          Nouveau questionnaire
        </AppLink>
      </li>
      <li>
        <a class="dropdown-item" target="_blank" :href="userProfile">
          Profil
        </a>
      </li>
      <li><hr class="dropdown-divider" /></li>
      <li>
        <AppLink
          :href="$route('logout')"
          method="post"
          as="button"
          type="button"
          class="dropdown-item"
        >
          Se déconnecter
        </AppLink>
      </li>
    </ul>
  </div>
</template>

<script>
import AuthMixin from '../mixins/AuthMixin'
import UserMixin from '../mixins/UserMixin'

export default {
  mixins: [AuthMixin, UserMixin],
  data() {
    return {
      dropdownId: 'userDropdownMenu',
    }
  },
  computed: {
    buttonLabel() {
      return this.isUserConnected ? 'Mon compte' : 'Se connecter'
    },
    isDropdownButton() {
      return this.isUserConnected ? 'dropdown-toggle' : null
    },
    adminPanelBaseLink() {
      return this.$page.props.services.host
    },
    userProfile() {
      return `${this.adminPanelBaseLink}/profil`
    },
  },
  methods: {
    login() {
      if (!this.isDropdownButton) {
        window.location = this.loginUrl
      }
    },
    isActiveRoute(route) {
      return this.$route().current(route) ? 'active' : null
    },
  },
}
</script>

<style>
</style>
